module.exports = __webpack_public_path__ + "img/compress.5de24e52.png";